import { useEffect, useState } from "react";

export const useInsiders = ({ ticker }: { ticker: string }) => {
    const [data, setData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!ticker) return;
        setIsLoading(true);
        setError(null);
        fetch(`/api/insiders/${ticker}`)
            .then(async resp => {
                if (!resp.ok) throw new Error("API error");
                return resp.json();
            })
            .then(setData)
            .catch(e => setError(e.message))
            .finally(() => setIsLoading(false));
    }, [ticker]);

    return { data, isLoading, error };
};
